import type { ButtonHTMLAttributes, ReactNode } from "react";
import { Spinner } from "./Spinner";

export type CtlSize = "sm" | "md" | "lg";
export type ButtonVariant = "primary" | "secondary" | "ghost" | "danger";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  size?: CtlSize;
  loading?: boolean;
  /** 글자 없이 아이콘만 든 단추 — 공통 `.b-ibtn`(정사각). aria-label 이 필수다. */
  icon?: boolean;
  children: ReactNode;
};

/** 공통 v3 의 `.b-btn` 을 그린다 — 모양·높이(sm 24 · md 32 · lg 36)·색은 전부 공통 components.css 다.
 *  크기는 **자리가 정한다** — 툴바·카드 안이면 md, 폼의 주 단추면 lg, 표 안이면 sm. */
export function Button({ variant = "secondary", size = "md", loading, icon, children, className, ...rest }: Props) {
  const cls = icon
    ? ["b-ibtn", size === "sm" ? "b-ibtn-sm" : "", `b-btn-${variant}`]
    : ["b-btn", `b-btn-${variant}`, size === "md" ? "" : `b-btn-${size}`];
  return (
    <button
      type="button"
      {...rest}
      className={[...cls, className].filter(Boolean).join(" ")}
      disabled={rest.disabled || loading}
      /* 도는 중이라는 사실은 모양(스피너)과 글자(aria-busy)로 함께 간다 — 색만으로 가르지 않는다. */
      aria-busy={loading || undefined}
    >
      {loading ? <Spinner size={size} /> : null}
      {children}
    </button>
  );
}
